export default "__VITE_ASSET__376c41b4__"